interface DocumentSubategory {
  id?: number;
  name?: string;
  companyId?: number;
  categoryId?: number;
}

export const newDocumentSubcategory = (): DocumentSubategory => {
  return {};
};

export default DocumentSubategory;
